export default function StructuredData() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Al-Buraq International',
    alternateName: 'شركة البراق الدولية',
    url: 'https://www.alburaq-int.com',
    logo: 'https://www.alburaq-int.com/assets/img/core-img/logo-h2.svg',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+218910767060',
      contactType: 'customer service',
      email: 'info@alburaqint.ly',
      areaServed: 'LY',
      availableLanguage: ['Arabic', 'English'],
    },
    sameAs: [
      'https://www.facebook.com/alburaq',
      'https://www.twitter.com/alburaq_int',
      'https://www.linkedin.com/company/alburaq',
      'https://www.instagram.com/alburaq',
    ],
  };

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Al-Buraq International',
    image: 'https://www.alburaq-int.com/assets/img/core-img/logo-h2.svg',
    '@id': 'https://www.alburaq-int.com',
    url: 'https://www.alburaq-int.com',
    telephone: '+218-000-000-0000',
    priceRange: '$$',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Tripoli',
      addressRegion: 'Tripoli',
      addressCountry: 'LY',
    },
    openingHoursSpecification: {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: [
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
      ],
      opens: '08:00',
      closes: '18:00',
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(localBusinessSchema) }}
      />
    </>
  );
}

